export default function ClassBean() {
    this.schId = -1
    this.parentId = -1
    this.schName = ''
    this.schStatus = 1
    this.schRemarks = ''
    this.label = ''
    this.value = ''
    this.grade = ''
}